import React from 'react';
import { useTranslation } from 'react-i18next';

const ProductPicker: React.FC = () => {
  const { t } = useTranslation('webflash');

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('firmware.selectProduct')}
      </h3>
      <select
        className="w-full border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
        disabled
      >
        <option>{t('firmware.noProducts')}</option>
      </select>
    </div>
  );
};

export default ProductPicker;
